import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import { navigateToPage } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import Sentry from 'Integrations/Sentry';

const useStyles = buildUseStyles('CompleteAccountOpeningButton', (() => ({
  root: {},
})));

const CompleteAccountOpeningButton = ({
  className,
  completed,
  resource,
}) => {
  const classes = useStyles();
  const { isAgent } = useUserContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleAccountOpeningWizardClick = async () => {
    if (completed) {
      return;
    }

    resource.withRelationship(
      fr.relationships.accountOpeningWizard.name,
      async (rel) => {
        try {
          const [accountOpeningStep] = await rel.link('related').get();
          navigateToPage(accountOpeningStep.link('self').url(), isAgent);
        } catch (err) {
          Sentry.createSentryErrorLog(err);
          displayErrorMessage('Error navigating to account opening');
        }
      },
      () => {},
    );
  };

  const label = completed ? 'Completed' : 'Complete Opening';

  return (
    <FDBox
      className={classNames(classes.root, className)}
    >
      <FDPrimaryActionButton
        test={'complete-account-button'}
        label={label}
        size={'sm'}
        onClick={handleAccountOpeningWizardClick}
      />
    </FDBox>
  );
};

CompleteAccountOpeningButton.defaultProps = {
  className: '',
  completed: false,
};

CompleteAccountOpeningButton.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  resource: PropTypes.object.isRequired,
};

export default CompleteAccountOpeningButton;
